<script setup>
import { computed } from 'vue';
import { Head, Link, useForm } from '@inertiajs/vue3';
import Button from 'primevue/button';
import GuestLayout from '@/Layouts/GuestLayout.vue';

const props = defineProps({
  status: {
    type: String,
  },
});

const form = useForm({});

const submit = () => {
  form.post(route('verification.send'));
};

const verificationLinkSent = computed(
    () => props.status === 'verification-link-sent',
);
</script>

<template>
  <GuestLayout>
    <Head title="Vérification de l'email"/>

    <div class="mt-6 text-sm text-gray-600">
      Merci pour votre inscription ! Avant de commencer, pourriez-vous
      vérifier votre adresse e-mail en cliquant sur le lien que nous vous
      avons envoyé ? Si vous n'avez pas reçu l'e-mail, nous vous en enverrons un autre.
    </div>

    <div
        class="mt-6 text-sm font-medium text-green-600"
        v-if="verificationLinkSent"
    >
      Un nouveau lien de vérification a été envoyé à l'adresse e-mail que
      vous avez fournie lors de votre inscription.
    </div>

    <form @submit.prevent="submit">
      <div class="myt-6 flex items-center justify-between">
        <Button type="submit" :disabled="form.processing">
          Envoyer un nouveau lien de vérification
        </Button>

        <Link
            :href="route('logout')"
            method="post"
            as="button"
            class="rounded-md text-sm text-gray-600 underline hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
        >Se déconnecter
        </Link>
      </div>
    </form>
  </GuestLayout>
</template>
